import Cookies from "../../libs/js-cookie/src/js.cookie";

var forEach = function(array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    } // forEach

class PromoBanner {
    constructor() {
        this.promoCheck();
    }

    promoCheck() {

            const promos = document.querySelectorAll('.promo-footer');
            var promo_id;
            var promo_cookie;
            var dismiss_button;
            var dismiss_close;
            var promo_self_hide;
            var promo_timeout;

            forEach(promos, function(index, value) {

                promo_id = value.getAttribute('id');
                promo_self_hide = value.classList.contains('self-hide');

                if (promo_self_hide) {
                    promo_timeout = value.getAttribute('timeout');
                    setTimeout(function() {
                        value.classList.add('hide-promo');
                    }, promo_timeout * 1000);
                }

                promo_cookie = Cookies.get('fsc-' + promo_id);

                if (undefined === promo_cookie) {
                    if (window.innerWidth >= 768 && value.classList.contains('hide-promo-mobile') || !value.classList.contains('hide-promo-mobile')) {
                        value.classList.add('show-promo');
                    }

                    value.setAttribute('aria-hidden', 'false');

                } else {

                    value.classList.add('hide-promo');
                    value.setAttribute('aria-hidden', 'true');

                } // if/else

                dismiss_close = document.getElementById('close-' + promo_id);

                dismiss_close.addEventListener('click', function() {

                    if (value.classList.contains('show-promo')) {
                        value.classList.remove('show-promo');
                        value.classList.add('hide-promo');
                        value.setAttribute('aria-hidden', 'true');
                    }
                    promo_id = value.getAttribute('id');
                    Cookies.set('fsc-' + promo_id, 'dismissed', { expires: 7 });

                });

            }); // forEach

        } // promoCheck()

} // PromoBanner
export default new PromoBanner();


// WEBPACK FOOTER //
// ./assets/components/promo/promo.js